export const FUEL_LEVEL = 10002;
export const CAN_EV_STATE_OF_CHARGE = 20590;
export const CAN_EV_DISTANCE_UNTIL_RECHARGE = 20591;
export const OBD_EV_STATE_OF_CHARGE = 722;
export const OBD_EV_DISTANCE_UNTIL_RECHARGE = 723;
